
import { language } from 'curvy';

export const english: language.TranslationDefinition = {
	locale: 'en-us',
	translations: {
		"REQUEST": "Request",
		"STUDENT": "Student",
      "INSTITUTION": "Institution",
		"TEMP_STAFF_REQUEST.NEW": "New Temp Staff Request",
		"TEMP_STAFF_REQUEST.DATE_TYPE": "Date Type",
		"TEMP_STAFF_REQUEST.PERIOD": "Period",
		"TEMP_STAFF_REQUEST.SINGLE_DAY": "Single Day",
		"TEMP_STAFF_REQUEST.DATE_FROM": "Date From",
		"TEMP_STAFF_REQUEST.DATE_TO": "Date To",
		"TEMP_STAFF_REQUEST.NUMBER_OF_WORKERS": "Number of Workers",
		"TEMP_STAFF_REQUEST.SHIFTS": "Shifts",
		"TEMP_REQUEST.ADD_NEW": "Add New Request",
		"TITLE": "Title",
		"TEMP_STAFF_REQUEST.APPLICATIONS": "Applications",
		"TEMP_STAFF_REQUEST.APPLICATION.NO_PERMISSION_TO_MODIFY": "You don't have permission to modify application.",
		"ACCEPT": "Accept",
		"ACCEPTED": "Accepted",
		"APPLICATION.ACCEPT.TITLE": "Accept Application",
		"APPLICATION.ACCEPT.MESSAGE": "Are you sure you want to accept this application?",
		"HR_NOTE": "HR Note",
		"NO_APPLICATIONS": "No applications",
		"ARRIVAL_START": "Start arrival",
		"ARRIVAL_END": "End arrival",
		"ADD_WORKING_HOURS":"Add working hours",
		"PLANNED_START":"Planned start",
		"PLANNED_END":"Planned end",
		"ACTUAL_START":"Start",
		"ACTUAL_END":"End",
		"PLAN_WORKING_HOURS": "Plan working hours",
		"TEMP_STAFF_REQUEST.APPLICATION.WORKING_HOURS_ADDED": "Added.",
		"TEMP_STAFF_REQUEST.STATUS.APPLICATIONS_OPEN": "",
		"TEMP_STAFF_REQUEST.STATUS.APPLICATIONS_FINISHED": "",
		"TEMP_STAFF_REQUEST.STATUS.WORKS_UNDERWAY": "",
		"TEMP_STAFF_REQUEST.STATUS.WORKS_FINISHED": "",
	}
};

export const croatian: language.TranslationDefinition = {
	locale: 'hr-hr',
	translations: {
		"REQUEST": "Zahtjev",
		"STUDENT": "Student",
      "INSTITUTION": "Ustanova",
		"TEMP_STAFF_REQUEST.NEW": "Novi zahtjev za radnicima",
		"TEMP_STAFF_REQUEST.DATE_TYPE": "Tip potrebe",
		"TEMP_STAFF_REQUEST.PERIOD": "Period",
		"TEMP_STAFF_REQUEST.SINGLE_DAY": "Jednokratno",
		"TEMP_STAFF_REQUEST.DATE_FROM": "Datum Od",
		"TEMP_STAFF_REQUEST.DATE_TO": "Datum Do",
		"TEMP_STAFF_REQUEST.NUMBER_OF_WORKERS": "Broj Radnika",
		"TEMP_STAFF_REQUEST.SHIFTS": "Radne smjene",
		"TEMP_REQUEST.ADD_NEW": "Dodaj novi zahtjev",
		"TITLE": "Naslov",
		"TEMP_STAFF_REQUEST.APPLICATIONS": "Prijave",
		"TEMP_STAFF_REQUEST.APPLICATION.NO_PERMISSION_TO_MODIFY": "Nemate dozvolu za izmjenu prijave.",
		"ACCEPT": "Prihvati",
		"ACCEPTED": "Prihvaćeno",
		"APPLICATION.ACCEPT.TITLE": "Prihvati prijavu",
		"APPLICATION.ACCEPT.MESSAGE": "Jeste li sigurni da želite prihvatiti ovu prijavu?",
		"HR_NOTE": "HR napomena",
		"NO_APPLICATIONS": "Nema prijava",
		"ARRIVAL_START": "Dolazak",
		"ARRIVAL_END": "Odlazak",
		"ADD_WORKING_HOURS":"Dodaj radne sate",
		"PLANNED_START":"Planirani početak",
		"PLANNED_END":"Planirani kraj",
		"ACTUAL_START":"Početak",
		"ACTUAL_END":"Kraj",
		"PLAN_WORKING_HOURS": "Planiranje radnih sati",
		"TEMP_STAFF_REQUEST.APPLICATION.WORKING_HOURS_ADDED": "Dodano.",
		"TEMP_STAFF_REQUEST.STATUS.APPLICATIONS_OPEN": "Prijave otvorene",
		"TEMP_STAFF_REQUEST.STATUS.APPLICATIONS_FINISHED": "Kandidati odabrani",
		"TEMP_STAFF_REQUEST.STATUS.WORKS_UNDERWAY": "U izvršavanju",
		"TEMP_STAFF_REQUEST.STATUS.WORKS_FINISHED": "Izvršeno",
	}
};

export const jobs_management_translations = [english, croatian];
